// Mock data for DVV Projects website

export const contactInfo = {
  addresses: {
    headOffice: `D.No 28-18-9, 2nd Floor, Timpany School Road,
Opposite Indian Overseas Bank,
Vuda Colony, Gonthinavanipalem, Gajuwaka,
Visakhapatnam, Andhra Pradesh 530026`,

branchOffice: `D.No 49-49-6, First Floor,
Beside Arka Hospital,
Santhipuram, Akkayyapalem,
Visakhapatnam, Andhra Pradesh 530016`,
  },

  phone: "+91 7288080999",
  whatsapp: "+91 7288080999",
  email: "info@dvvprojects.com",

  businessHours: "9:00 AM – 9:00 PM",

  social: {
    facebook: "https://www.facebook.com/people/DVV-Projects/61577699189159/",
    instagram: "https://instagram.com/dvvprojects",
  },

  maps: {
    headOffice:
      "https://www.google.com/maps?q=2nd+Floor,+28-18-9,+Timpany+School+Road,+Opposite+Indian+Overseas+Bank,+Vuda+Colony,+Gonthinavanipalem,+Gajuwaka,+Visakhapatnam,+Andhra+Pradesh+530026&output=embed",

    branchOffice:
      "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3800.1410059960203!2d83.30386299999999!3d17.737993999999997!2m3!1f0!2f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDQ0JzE2LjgiTiA4M8KwMTgnMTMuOSJF!5e0!3m2!1sen!2sin!4v1783996750613!5m2!1sen!2sin",
  },
};

export const projects = [
  // =====================
  // RESIDENTIAL PROJECTS
  // =====================
  {
  id: "steel-city-gardens",
  name: "DVV’s Steel City Gardens",
  category: "residential",
  location: "Near Anakapalli",

  tagline: "Premium open plots in a prime growth corridor.",

  status: "Ready for Construction",

  approvals: [
    "VMRDA Approved",
    "Bank Loan Available (Up to 75%)"
  ],

  images: [
    "/steelcity1.png",
    "/steelcity2.png",
    "/steelcity3.png"
  ],

  // ⚠️ Important: maps.app.goo.gl will NOT work → use embed format
  mapEmbedUrl: "https://www.google.com/maps?q=17.6735,82.9995&output=embed",

  about:
    "DVV’s Steel City Gardens is a premium gated plotted development near Anakapalli, strategically located close to major industrial hubs and growth corridors. With modern infrastructure, greenery, and excellent connectivity, it is ideal for both residential living and long-term investment.",

  highlights: [
    "VMRDA Approved Layout",
    "60 Ft & 40 Ft Wide Roads",
    "Avenue Plantation with Greenery",
    "Underground Drainage System",
    "Water Facility Available",
    "Electricity with Street Lights",
    "Ready for Construction",
    "Safe & Secure Gated Layout",
    "High Growth Investment Zone"
  ],

  amenities: [
    "Street Lighting",
    "Underground Drainage",
    "Water Facility",
    "Green Landscapes",
    "Wide Internal Roads"
  ],

  projectInfo: {
    Type: "Residential Open Plots"
  },

  locationAdvantages: [
    "2 KM to NH16 National Highway",
    "4 KM to AMNS (Arcelor Mittal Nippon Steel Plant)",
    "3 KM to Revu Polavaram Beach",
    "3 KM to Coastal Corridor Expressway",
    "Close to Anakapalli Town",
    "Fast Developing Industrial Zone",
    "High Appreciation Potential Area"
  ],

  whyChoose: [
    "Strategic location near steel plant & industrial corridor",
    "Excellent connectivity to highway & coastal infrastructure",
    "Ideal for both living and investment",
    "High appreciation potential due to rapid development",
    "Developed by DVV Projects – Trusted since 2010"
  ]
},
  {
  id: "brundavanam",
  name: "DVV’s Brundavanam",
  category: "residential",
  location: "Duvvada",
  tagline: "A mega gated residential community for peaceful and future-ready living.",
  status: "Open Plots",
  approvals: ["VMRDA Approved", "RERA Approved"],

  images: [
    "/brundavanam1.png",      // Image 1 (with name)
  "/brundavanam2.png",    // Image 2
  "/brundavanam3.png"
  ],

  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.205221815227!2d83.2911447152407!3d17.723627289206404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a395d9023ecf6df%3A0x2565c2eb3fd53087!2sDuvvada%2C%20Visakhapatnam%2C%20Andhra%20Pradesh!5e0!3m2!1sen!2sin!4v1700000000000",

  about:
    "DVV’s Brundavanam at Duvvada is an 80-acre mega gated residential layout offering serene living with excellent urban connectivity. Designed with premium infrastructure and modern amenities, it is ideal for families, professionals, and long-term investors.",

  brochureUrl: "/brochures/DVV’s Brundavanam.pdf",

  highlights: [
    "80 Acres Mega Gated Community",
    "40 & 60 Feet Wide Blacktop Roads",
    "Theme Parks & Green Spaces",
    "Clubhouse & Children’s Play Areas",
    "Underground Drainage & Electricity",
    "VMRDA & RERA Approved"
  ],

  amenities: [
    "Clubhouse",
    "Children’s Play Area",
    "Box Cricket Arena",
    "Play School",
    "Street Lighting",
    "Footpaths"
  ],

  projectInfo: {
    Type: "Residential Plots",
    "Project Area": "80 Acres",
    "Plot Sizes": "167, 183 & 200 sq.yd"
  },

  locationAdvantages: [
    "6 KM from Duvvada Railway Station",
    "2 KM from Jagannadhapuram Satellite Railway Station",
    "6 KM from SEZ",
    "4 KM from Sabbavaram Highway Junction",
    "6 KM from Central Universities Hub"
  ],

  whyChoose: [
    "Perfect blend of nature, comfort & connectivity",
    "High appreciation potential due to infrastructure & railway development",
    "Ideal for residential living and long-term investment",
    "Plot Sizes Starting From 167, 183, 200 Square Yards"
  ]
},


  {
  id: "blue-sky",
  name: "DVV’s Blue Sky",
  category: "residential",
  location: "Atchyutapuram",
  tagline: "Modern plotted living surrounded by open spaces and growth corridors.",
  status: "Selling Fast",
  approvals: ["VMRDA Approved", "RERA Approved"],
  images: [
    "/bluesky1.png",
    "/bluesky2.png",
    "/bluesky3.png"
  ],
  mapEmbedUrl: "https://www.google.com/maps?q=17.584956,83.023532&output=embed",

  about:
    "DVV’s Blue Sky is a 20-acre mega gated plotted development offering modern infrastructure, open spaces, and strong connectivity to Vizag’s industrial and growth hubs.",
  brochureUrl: "/brochures/DVV’s Blue Sky.pdf",
  highlights: [
    "20 Acres Mega Gated Community",
    "40 & 60 Feet Wide Blacktop Roads",
    "Theme Parks",
    "Underground Drainage",
    "VMRDA & RERA Approved"
  ],
  amenities: ["Parks", "Street Lighting", "Footpaths", "Drainage System"],
  projectInfo: {
    Type: "Residential Plots",
    "Project Area": "20 Acres"
  },
  locationAdvantages: [
    "5 KM from Atchyutapuram 4-Road Junction",
    "4 KM from BAARC",
    "9 KM from SEZ",
    "10 KM from Pharma Hub",
    "15 KM from Vizag Steel Plant"
  ],
  whyChoose: [
    "Ideal balance of nature, infrastructure & growth",
    "High appreciation potential due to SEZ & Pharma Hub proximity",
    "Peaceful environment with tourist & eco-zone surroundings",
    "Developed by DVV Projects – Trusted Since 2010"
  ]
},

  {
  id: "highways-paradise",
  name: "DVV’s Highways Paradise",
  category: "residential",
  location: "Anakapalli",
  tagline: "A mega gated community at the heart of connectivity and growth.",
  status: "New Launch",
  approvals: ["VMRDA Approved", "RERA Approved"],
  images: [
    "/DHP11.png",
    "/DHP2.png",
    "/DHP3.png"
  ],
  mapEmbedUrl: "https://www.google.com/maps?q=17.584956,83.023532&output=embed",

  about:
    "DVV’s Highways Paradise is a 120-acre mega gated plotted development located near major highway corridors, ensuring excellent connectivity and strong future appreciation.",
  highlights: [
    "120 Acres Mega Gated Community",
    "80, 60 & 40 Feet Wide CC Roads",
    "Theme Parks",
    "Underground Drainage",
    "Prime Highway Connectivity"
  ],
  amenities: ["Parks", "Footpaths", "Street Lighting", "Drainage System"],
  projectInfo: {
    Type: "Residential Plots",
    "Project Area": "120 Acres"
  },
  locationAdvantages: [
    "1 KM from Anakapalli Town",
    "2 KM from Anakapalli Junction",
    "15 KM from SEZ",
    "7 KM from Pharma Hub",
    "35 KM from Nippon Mittal Steel Plant"
  ],
  whyChoose: [
    "Prime highway-facing location with excellent connectivity",
    "Strong appreciation driven by industrial, pharma & SEZ growth",
    "Ideal for long-term investment and residential development",
    "Developed by DVV Projects – Trusted Real Estate Brand since 2010"
  ]
},

  {
  id: "golden-valley",
  name: "DVV’s Golden Valley",
  category: "residential",
  location: "Bhogapuram",
  tagline: "Premium gated living near the upcoming international airport.",
  status: "Premium Project",
  approvals: ["VMRDA Approved", "RERA Approved"],
  images: [
    "/GV1.png",      // Image 1 (with name)
  "/GV2.png",    // Image 2
  "/GV3.png"
  ],
  mapEmbedUrl: "https://www.google.com/maps?q=18.107086,83.522650&output=embed",

  about: "DVV’s Golden Valley is a 30-acre mega gated residential project near Bhogapuram International Airport...",
  highlights: [
    "30 Acres Mega Gated Community",
    "40 & 60 Feet Wide CC Roads",
    "Airport Proximity",
    "Theme Parks",
    "Premium Living"
  ],
  amenities: ["Landscaped Parks", "Footpaths", "Street Lighting", "Drainage System"],
  projectInfo: {
    Type: "Residential Plots",
    "Project Area": "30 Acres"
  },
  locationAdvantages: [
    "8 KM from Bhogapuram International Airport",
    "2 KM from NH-16",
    "15 KM from IT Hubs",
    "10 KM from Bheemili Beach"
  ],
  whyChoose: [
    "Prime location in the high-growth airport development zone",
    "Ideal mix of luxury, connectivity & nature",
    "Excellent appreciation driven by airport, IT & industrial expansion",
    "Perfect for premium living or long-term investment",
    "Developed by DVV Projects – Trusted Real Estate Brand since 2010"
  ]
},


  {
    id: "amazon-county",
    name: "DVV’s Amazon County",
    category: "residential",
    location: "Lankelapalem",
    tagline: "Nature-inspired gated living with premium urban comforts.",
    status: "Open Plots",
    approvals: ["VMRDA Approved", "RERA Approved"],
    images: [
      "/AC1.png",
      "/AC2.png",
      "/AC3.png"
    ],
    mapEmbedUrl:
      "https://www.google.com/maps?q=17.688224,83.085031&output=embed",

    about:
      "DVV’s Amazon County is a 50-acre mega gated residential community offering premium amenities, green spaces, and excellent connectivity to education and industrial hubs.",
    highlights: [
      "50 Acres Mega Gated Community",
      "80, 60 & 40 Feet Wide CC Roads",
      "Premium Clubhouse & Swimming Pool",
      "Underground Electricity",
      "In-Community Stores & Play School"
    ],
    amenities: ["Clubhouse", "Swimming Pool", "Parks", "Play School", "Footpaths"],
    projectInfo: {
      Type: "Residential Plots",
      "Project Area": "50 Acres"
    },
    locationAdvantages: [
      "2 KM from Lankelapalem",
      "5 KM from Anakapalli Junction",
      "12 KM from Central Universities Hub",
      "5 KM from Pharma Hub"
    ],
    whyChoose: [
     "A rare blend of nature, luxury & infrastructure",
     "Ideal for family living with lifestyle amenities",
     "Strong appreciation potential due to education, pharma & industrial growth",
     "Peaceful gated environment with urban conveniences inside",
     "Developed by DVV Projects – Trusted Real Estate Brand since 2010"
]


  },
  {
  id: "north-fields",
  name: "DVV’s North Fields",
  category: "residential",
  location: "Tarluvada",
  tagline: "Smart residential plots in a high-growth IT & data center corridor.",
  status: "Open Plots",
  approvals: ["VMRDA Approved", "RERA Approved"],

  images: [
    "/NF1.png",
    "/NF2.png",
    "/NF3.png"
  ],

  mapEmbedUrl:
    "https://www.google.com/maps?q=17.933802,83.324547&output=embed",


  about:
    "DVV’s North Fields at Tarluvada is a well-planned 25-acre mega gated residential plotted development located in one of Visakhapatnam’s fastest-growing IT and data center corridors. Designed for modern living and long-term appreciation, it offers premium infrastructure, green spaces, and excellent connectivity.",


  highlights: [
    "25 Acres Mega Gated Community",
    "40 & 60 Feet Wide Blacktop Roads",
    "Landscaped Theme Parks",
    "Underground Drainage System",
    "Reliable Electricity & Street Lighting",
    "VMRDA & RERA Approved"
  ],

  amenities: [
    "Theme Parks",
    "Street Lighting",
    "Footpaths",
    "Underground Drainage",
    "Electricity Infrastructure"
  ],

  projectInfo: {
    Type: "Residential Plots",
    "Project Area": "25 Acres"
  },

  locationAdvantages: [
    "4 KM from Google & Jio Data Centers – Tarluvada",
    "5 KM from Nellakundeelu Junction",
    "5 KM from Sontyam Educational Hub",
    "15 KM from Simhachalam Temple",
    "25 KM from Bhogapuram International Airport",
    "12 KM from International Cricket Stadium"
  ],
  whyChoose: [
  "Prime location in the IT and Data Center growth corridor",
  "Ideal for professionals, families, and long-term investors",
  "Strong appreciation driven by IT, education, and infrastructure development",
  "Peaceful gated community with excellent urban connectivity",
  "Developed by DVV Projects – Trusted Real Estate Brand since 2010"
],

},
{
  id: "defence-garden",
  name: "DVV’s Defence Garden",
  category: "residential",
  location: "Rambilli",
  tagline: "Secure and serene gated living near India’s largest naval base.",
  status: "Open Plots",
  approvals: ["VMRDA Approved", "RERA Approved"],

  images: [
    "/DG1.png",
    "/DG2.png",
    "/DG3.png"
  ],

  mapEmbedUrl:
    "https://www.google.com/maps?q=17.502063,82.935271&output=embed",


  about:
    "DVV’s Defence Garden at Rambilli is a thoughtfully planned 20-acre mega gated residential plotted development near India’s largest naval base. It offers secure, peaceful living with strong future appreciation driven by defence and coastal infrastructure growth.",

  highlights: [
    "20 Acres Mega Gated Community",
    "40 & 60 Feet Wide Blacktop Roads",
    "Landscaped Theme Parks",
    "Underground Drainage System",
    "Reliable Electricity & Street Lighting",
    "VMRDA & RERA Approved"
  ],

  amenities: [
    "Theme Parks",
    "Street Lighting",
    "Footpaths",
    "Drainage System"
  ],

  projectInfo: {
    Type: "Residential Plots",
    "Project Area": "20 Acres"
  },

  locationAdvantages: [
    "4 KM from India’s Largest Naval Base – Rambilli",
    "5 KM from the Beach",
    "20 KM from Atchyutapuram SEZ Hub",
    "1 KM from Coastal Corridor Express Highway",
    "30 KM from Anakapalli",
    "30 KM from Nippon Mittal Steel Plant – Nakkapalli"
  ],
  whyChoose: [
  "Highly secure zone with defence and coastal infrastructure",
  "Ideal for retirement living and family settlements",
  "Strong appreciation potential driven by naval base and coastal corridor",
  "Peaceful environment close to beach and nature",
  "Developed by DVV Projects – Trusted Real Estate Brand since 2010"
]

},


  // =====================
  // FARMLAND PROJECTS
  // =====================
 {
  id: "suvarnavanam",
  name: "DVV’s Suvarnavanam",
  category: "farmland",
  location: "Butchayyapeta, Visakhapatnam District",

  tagline:
    "A premium farmland community designed for sustainable living, leisure, and long-term wealth creation.",

  status: "Open Farmland",

  approvals: [
    "Ready for Registration"
  ],

  images: [
    "/suvarnam1.png",
    "/suvarnam2.png",
    "/suvarnam3.png"
  ],

  mapEmbedUrl:
    "https://www.google.com/maps?q=17.7947785,82.8986566&output=embed",


  about:
    "DVV’s Suvarnavanam is a well-planned 30-acre premium farmland project at Butchayyapeta, offering a perfect blend of nature, agriculture, and leisure living. Designed with wide internal roads, resort-style amenities, and lifetime maintenance, it is ideal for sustainable farming, weekend retreats, and long-term investment.",

  highlights: [
    "30 Acres Premium Farmland Project",
    "All 30 Feet Wide Internal Roads",
    "Resort-Style Development",
    "Lifetime Maintenance Assurance",
    "Secure Investment"
  ],

  amenities: [
    "Resort",
    "Swimming Pool",
    "Children Play Area",
    "Compound Wall",
    "Grand Entrance Arch",
    "Electricity Connection",
    "Internal Access Roads",
    "Irrigation Facilities",
    "Free Resort Accommodation for Owners"
  ],

  projectInfo: {
    Type: "Farmland Plots",
    "Project Area": "30 Acres",
    "Plot Sizes": "1 – 5 Acres",
    Maintenance: "Lifetime"
  },

  locationAdvantages: [
    "15 KM from Anakapalli",
    "35 KM from Gajuwaka",
    "6 KM from Chodavaram",
    "60 KM from Lambasingi & Vanjangi Hills",
    "30 KM from Nippon & Mittal Steel Plants"
  ],

  whyChoose: [
    "Ideal for sustainable agriculture and eco-living",
    "Resort-style amenities within farmland community",
    "Sandalwood plantation with sales support",
    "Excellent long-term appreciation potential",
    "Developed by DVV Projects – Trusted Real Estate Brand since 2010"
  ]
},
  {
  id: "suvarnavanam-hill-view",
  name: "DVV’s Suvarnavanam Hill View",
  category: "farmland",
  location: "Kothakota",
  tagline: "Hill-view farm living with resort luxury and red sandalwood investment.",
  status: "Premium Project",
  approvals: [
    "Ready for Registration"
  ],
  images: [
    "/suvarnamhill1.png",
    "/suvarnamhill2.png",
    "/suvarnamhill3.png"
  ],
  mapEmbedUrl: "https://www.google.com/maps?q=17.772704,82.656687&output=embed",


  about:
    "DVV’s Suvarnavanam Hill View is an exclusive 50-acre premium farmland development at Kothakota, surrounded by scenic hills and natural landscapes. Designed for eco-luxury living and high-value green investment, the project combines resort-style amenities, adventure experiences, and red sandalwood plantation opportunities—ideal for weekend retreats, farmhouse living, and long-term appreciation.",
  highlights: [
    "50 Acres Premium Farmland Project",
    "Scenic Hill-View Location",
    "Red Sandalwood Plantation Investment",
    "Resort-Style Living",
    "Eco-Luxury Environment"
  ],
  amenities: [
    "Swimming Pools",
    "Rain Dance Area",
    "Camp Fire Zones",
    "Children’s Play Area",
    "Resort-Style Amenities",
    "Peaceful & Secure Environment"
  ],
  locationAdvantages: [
    "15 KM from Narsipatnam",
    "8 KM from Kalyanapu Lova Reservoir",
    "4 KM from 200-Feet Bheemunipatnam–Narsipatnam Main Road",
    "15 KM from Chodavaram",
    "30 KM from Lambasingi (Andhra Kashmir)",
    "50 KM from Vanjangi Hills"
  ],
  projectInfo: {
    Type: "Premium Farmland",
    TotalArea: "50 Acres",
    IdealFor: "Weekend Homes, Eco-Tourism, Retirement Living",
    Developer: "DVV Projects (Trusted since 2010)"
  }
},

  {
  id: "srivanam",
  name: "DVV’s Srivanam",
  category: "farmland",
  location: "Vepada",
  tagline: "Exclusive white sandalwood investment with resort-style living near the Vizag–Araku belt.",
  status: "Premium Investment Project",
  approvals: ["Ready for Registration"],

  images: [
    "/srivanam1.png",
    "/srivanam2.png",
    "/srivanam3.png"
  ],

  // ✅ EMBED URL (maps.app.goo.gl will NOT work)
  mapEmbedUrl: "https://www.google.com/maps?q=18.005139,83.062382&output=embed",


  about:
    "DVV’s Srivanam at Vepada is a premium white sandalwood–focused investment project that blends eco-friendly plantation returns with resort-style living. Located close to the Vizag–Araku belt, the project offers a peaceful green environment, adventure experiences, and strong long-term appreciation potential.",

  brochureUrl: "/brochures/DVV’s Srivanam.pdf",

  highlights: [
    "White Sandalwood Investment Project",
    "Resort-Style Development",
    "Eco-Friendly Plantation Living",
    "Adventure & Nature Experiences"
  ],

  amenities: [
    "Modern Clubhouse",
    "Traditional Goshala (Cow Shelter)",
    "Children’s Play Area",
    "Trekking & Nature Trails",
    "Internal Roads",
    "Security"
  ],

  projectInfo: {
    Type: "White Sandalwood Farmland",
    "Total Area": "Premium Development",
    "Investment Type": "Long-Term Plantation & Eco Tourism"
  },

  locationAdvantages: [
    "5 KM from Vizag – Araku Road",
    "10 KM from Devarapalli Waterfalls",
    "10 KM from S. Kota",
    "20 KM from Kothavalasa",
    "Close to hills, forest zones & tourist destinations"
  ],

  whyChoose: [
    "Pure white sandalwood investment opportunity",
    "High long-term returns backed by plantation value",
    "Peaceful lifestyle near hills & waterfalls",
    "Ideal for weekend retreats, retirement living & green investors",
    "Developed by DVV Projects – Trusted brand since 2010"
  ]
},

  {
  id: "ananda-brundavanam",
  name: "DVV’s Ananda Brundavanam",
  category: "farmland",
  location: "Nuthagondipalem (Near Tallapalem Junction)",
  tagline: "Premium mahogany plantation investment with zero lock-in and excellent highway & rail connectivity.",
  status: "Limited Availability",
  approvals: [
    "Land Conversion Completed"
  ],
  images: [
    "/ananda1.png",
    "/ananda2.png",
    "/ananda3.png"
  ],

  // ✅ Use ONLY embed URL for ifram
 mapEmbedUrl: "https://www.google.com/maps?q=17.587466,82.864235&output=embed",


  about:
    "DVV’s Ananda Brundavanam, located at Nuthagondipalem near Tallapalem Junction, is a professionally planned plantation investment project offering completed land conversion, zero lock-in flexibility, and strong long-term returns. The project focuses on mahogany plantations supported by water apple and guava trees, making it an ideal choice for safe, managed green investment.",

  brochureUrl: "/brochures/DVV’s Ananda Brundavanam.pdf",

  highlights: [
    "Mahogany Plantation Project",
    "Zero Lock-In Period",
    "10 Years Free Maintenance",
    "Converted Land with Clear Documentation",
    "Professionally Managed Investment"
  ],

  amenities: [
    "Mahogany Tree Plantation",
    "Water Apple & Guava Plantations",
    "Internal Roads",
    "Irrigation Support",
    "Fencing",
    "Security"
  ],

  projectInfo: {
    Type: "Plantation Investment",
    "Plantation": "Mahogany, Water Apple & Guava",
    Maintenance: "10 Years Free",
    Ownership: "No Lock-In Period"
  },

  locationAdvantages: [
    "500 meters from NH-16",
    "2 KM from Narsingapalli Railway Station",
    "3 KM from Tallapalem Junction",
    "4 KM from Yelamanchili",
    "10 KM from Anakapalli",
    "25 KM from Arcelor Mittal Nippon Steel Company"
  ],

  whyChoose: [
    "Immediate usability with completed land conversion",
    "Flexible investment with zero lock-in",
    "Long-term returns from mahogany and fruit plantations",
    "Excellent appreciation due to NH-16, rail & industrial growth",
    "Ideal for safe, professionally managed plantation investment",
    "Developed by DVV Projects – Trusted since 2010"
  ]
},
{
  id: "chandan-valley",
  name: "DVV’s Chandan Valley",
  category: "farmland",
  location: "Pinatatrimi, Bhogapuram",
  tagline: "Mega red sandalwood investment project near the international airport corridor.",
  status: "Mega Investment Project",
  approvals: ["Ready for Registration"],

  images: [
    "/chandan1.png",
    "/chandan2.png",
    "/chandan3.png"
  ],

  mapEmbedUrl: "https://www.google.com/maps?q=18.177363,83.578250&output=embed",


  about:
    "DVV’s Chandan Valley at Pinatatrimi near Bhogapuram is a prestigious 60-acre mega red sandalwood investment project located in the fast-growing international airport and industrial corridor. Designed for high-value green investment, it combines luxury resort living with long-term appreciation.",

  highlights: [
    "60 Acres Mega Red Sandalwood Project",
    "Airport & Industrial Growth Corridor",
    "Resort-Style Development",
    "Secure Gated Environment",
    "Pollution-Free Natural Surroundings"
  ],

  amenities: [
    "Resort",
    "Swimming Pool",
    "Modern Clubhouse",
    "Internal Roads",
    "Security",
    "Landscaped Green Zones"
  ],

  projectInfo: {
    Type: "Red Sandalwood Plantation",
    TotalArea: "60 Acres",
    IdealFor: "Long-Term Investors & Eco Investment"
  },

  locationAdvantages: [
    "Adjoining Vijayanagaram–Ranastalam NH",
    "5 KM from Pydibheemavaram Industrial Corridor",
    "15 KM from Bhogapuram International Airport",
    "25 KM from IT Corridors",
    "10 KM from Ramateerdam Temple"
  ],

  whyChoose: [
    "Prime airport & industrial corridor location",
    "High-value red sandalwood plantation",
    "Luxury resort lifestyle",
    "Strong appreciation from airport & IT growth",
    "Developed by DVV Projects – Trusted since 2010"
  ]
},
{
  id: "arunya",
  name: "DVV’s Arunya",
  category: "farmland",
  location: "Tattabandha",
  tagline: "Premium gated farm-living community with resort-style amenities and eco-investment value.",
  status: "Premium Farm Living",
  approvals: ["Ready For Registration"],

  images: [
    "/DA1.png",
    "/DA2.png",
    "/DA3.png"
  ],

  mapEmbedUrl: "https://www.google.com/maps?q=17.718582,82.784746&output=embed",


  about:
    "DVV’s Arunya at Tattabandha is a 50-acre premium gated farm-living development designed for serene farmhouse living, resort-style comfort, and long-term eco-investment. Surrounded by nature and planned with modern infrastructure, Arunya offers a peaceful escape while staying well connected to nearby towns.",

  highlights: [
    "50 Acres Premium Gated Farm Community",
    "Farmhouse Living Concept",
    "White Sandalwood Plantation",
    "Resort-Style Amenities",
    "Lifetime Maintenance Support",
    "Iconic Grand Entrance Arch",
    "30 Feet Wide Internal Roads",
    "Secure Green Environment"
  ],

  amenities: [
    "Resort-Style Amenities",
    "Children’s Play Area",
    "Electricity Infrastructure",
    "Wide Internal Roads",
    "Security",
    "Green Landscaped Zones"
  ],

  projectInfo: {
    Type: "Farm Living / Farmland",
    TotalArea: "50 Acres",
    Plantation: "White Sandalwood",
    IdealFor: "Farmhouse Living, Weekend Retreats & Long-Term Investment"
  },

  locationAdvantages: [
    "24 KM from Anakapalli",
    "15 KM from Ravikamatham",
    "20 KM from Narsipatnam"
  ],

  whyChoose: [
    "Perfect for farmhouse living and retirement plans",
    "High long-term returns through white sandalwood plantation",
    "Hassle-free ownership with lifetime maintenance",
    "Resort-style lifestyle in peaceful surroundings",
    "Developed by DVV Projects – Trusted since 2010"
  ]
}


];


export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Government Employee",
    location: "DVV’s Brundavanam",
    rating: 5,
    text: "DVV Projects provided excellent service from the very first site visit.\n\nThe VMRDA approval, clear documentation, and transparent pricing gave us full confidence to invest.\n\nThe team guided us through registration smoothly, making the entire process stress-free.",
    avatar: "https://media.istockphoto.com/id/1864418023/photo/portrait-young-successful-indian-businessman-man-in-shirt-smiling-and-looking-at-camera.jpg?s=612x612&w=0&k=20&c=r1mEP5K4EpPVxDS1zW6K-FsZVzcCgc_iFvb7lWU0JuM="
  },
  {
    id: 2,
    name: "Lakshmi Devi",
    role: "Business Owner",
    location: "DVV’s Blue Sky",
    rating: 5,
    text: "Best decision we made! The villa plot we purchased has all amenities as promised. The location is fantastic and the value has already appreciated. DVV team is reliable and trustworthy.",
    avatar: "https://media.istockphoto.com/id/1566675636/photo/portrait-of-confident-mature-woman-wearing-formalwear-with-arms-crossed-standing-against.jpg?s=612x612&w=0&k=20&c=ZUv5-hDhvkGB4TFbNEyMRw7KOh-4C6knftNiMEMPRiQ="
  },
  {
    id: 3,
    name: "Venkat Rao (NRI)",
    role: "IT Professional, USA",
    location: "DVV’s Golden Valley",
    rating: 5,
    text: "As an NRI, I was skeptical about investing remotely. But DVV Projects made everything easy. All documents were clear, approvals were genuine, and they kept me updated throughout. Great team!",
    avatar: "https://media.istockphoto.com/id/1277971635/photo/portrait-of-a-smiling-man-of-indian-ethnicity.jpg?s=612x612&w=0&k=20&c=CnPwvagPlklsAjejUNkuKv_QXtaXPYFQ64AQYb-IAjA="
  },
  {
    id: 4,
    name: "Priya & Karthik",
    role: "Young Professionals",
    location: "DVV’s Suvarnavanam",
    rating: 5,
    text: "We booked our first plot with DVV Projects and couldn't be happier! The payment plans were flexible and the entire process was hassle-free. Looking forward to building our dream home here.",
    avatar: "https://img.freepik.com/premium-photo/portrait-happy-indian-couple-embracing-smiling-romantic-cheerful-traditional-outfit_636346-1103.jpg?semt=ais_hybrid&w=740&q=80"
  }
];

export const stats = [
  { label: "Projects Completed", value: 7, suffix: "+" },
  { label: "Years of Excellence", value: 15, suffix: "+" },
  { label: "Plots Sold", value: 1200, suffix: "+" },
  { label: "Happy Families", value: 1200, suffix: "+" }
];

export const trustBadges = [
  { name: "VMRDA Approved", icon: "shield-check" },
  { name: "RERA Approved", icon: "file-check" },
  { name: "Ready for Registration", icon: "clipboard-check" },
  { name: "5★ Google Rating", icon: "star" }
];


export const blogPosts = [
  {
    id: 1,
    title: "Why Visakhapatnam is the Next Real Estate Hotspot",
    slug: "visakhapatnam-real-estate-hotspot",
    excerpt: "Discover why Vizag is attracting investors from across India and abroad. Learn about the growth corridors, IT parks, and infrastructure developments driving property values.",
    author: "DVV Projects Team",
    date: "2025-01-15",
    readTime: "5 min read",
    category: "Market Insights",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800",
    content: "Full article content here..."
  },
  {
    id: 2,
    title: "Understanding VMRDA & RERA: A Complete Guide for Property Buyers",
    slug: "vmrda-rera-guide",
    excerpt: "Everything you need to know about VMRDA approvals and RERA registration. Learn how to verify approvals and why they matter for your investment.",
    author: "Legal Team",
    date: "2025-01-10",
    readTime: "7 min read",
    category: "Legal Guide",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800",
    content: "Full article content here..."
  },
  {
    id: 3,
    title: "5 Key Factors to Consider When Buying a Plot in Vizag",
    slug: "buying-plot-vizag-factors",
    excerpt: "Expert tips on location selection, documentation, amenities, and future growth potential. Make an informed decision for your next property investment.",
    author: "Property Advisors",
    date: "2025-01-05",
    readTime: "6 min read",
    category: "Buying Guide",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800",
    content: "Full article content here..."
  }
];

export const careerOpenings = [
  {
    id: 1,
    title: "Receptionist",
    department: "Administration",
    location: "Visakhapatnam Office",
    type: "Full-time",
    experience: "0-2 years",
    description: "We are looking for a friendly and professional receptionist to be the first point of contact for visitors and clients. The ideal candidate will have excellent communication skills and a welcoming personality.",
    responsibilities: [
      "Greet and assist visitors and clients",
      "Answer and direct phone calls",
      "Manage appointment scheduling",
      "Handle inquiries and provide information about projects",
      "Maintain reception area and office supplies"
    ],
    requirements: [
      "Excellent communication skills in Telugu and English",
      "Professional appearance and demeanor",
      "Basic computer knowledge (MS Office)",
      "Prior experience in reception/customer service preferred",
      "Flexible with working hours (9 AM - 9 PM shifts)"
    ]
  }
];

export const galleryItems = [
  {
    id: 1,
    type: "image",
    category: "projects",
    title: "DVV GreenCourt - Entrance Gate",
    url: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200",
    thumbnail: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400"
  },
  {
    id: 2,
    type: "image",
    category: "construction",
    title: "Site Development - Aerial View",
    url: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1200",
    thumbnail: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400"
  },
  {
    id: 3,
    type: "video",
    category: "construction",
    title: "Time-lapse Construction",
    url: "https://www.pexels.com/video/aerial-view-of-a-construction-site-3129671/",
    thumbnail: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400"
  },
  {
    id: 4,
    type: "image",
    category: "projects",
    title: "DVV OakVillas - Layout",
    url: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200",
    thumbnail: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=400"
  },
  {
    id: 5,
    type: "image",
    category: "events",
    title: "Plot Handover Ceremony",
    url: "https://images.unsplash.com/photo-1511578314322-379afb476865?w=1200",
    thumbnail: "https://images.unsplash.com/photo-1511578314322-379afb476865?w=400"
  },
  {
    id: 6,
    type: "image",
    category: "construction",
    title: "Infrastructure Development",
    url: "https://images.unsplash.com/photo-1590859808308-3d2d9c515b1a?w=1200",
    thumbnail: "https://images.unsplash.com/photo-1590859808308-3d2d9c515b1a?w=400"
  }
];

export const approvals = [
  {
    id: "vmrda",
    name: "VMRDA Approval",
    description: "Visakhapatnam Metropolitan Region Development Authority (VMRDA) approval ensures that the layout complies with all urban planning regulations and development norms set by the government.",
    projects: ["DVV GreenCourt", "DVV OakVillas", "DVV RiverView"],
    documentUrl: "/documents/vmrda-approval.pdf"
  },
  {
    id: "rera",
    name: "RERA Registration",
    description: "Real Estate Regulatory Authority (RERA) registration provides transparency and accountability. All project details, timelines, and financial information are registered and publicly accessible.",
    projects: ["DVV OakVillas", "DVV Sunrise Flats"],
    documentUrl: "/documents/rera-registration.pdf"
  },

];

export const whyDVV = [
  {
    icon: "shield-check",
    title: "Verified Approvals",
    description: "All projects carry genuine VMRDA and RERA approvals with clear title deeds, ensuring legal compliance and peace of mind."
  },
  {
    icon: "map-pin",
    title: "Prime Locations",
    description: "Strategically located properties in growth corridors near IT parks, educational institutions, and key infrastructure."
  },
  {
    icon: "trending-up",
    title: "Value Appreciation",
    description: "Properties in developing areas of Visakhapatnam with proven track record of value appreciation over time."
  }
];

export const nearbyGrowth = [
  { name: "Google Data Center", distance: "5 km" },
  { name: "Vizag IT Park", distance: "8 km" },
  { name: "Beach Road", distance: "12 km" },
  { name: "Airport", distance: "15 km" }
];

// Form submission placeholder webhook
export const FORM_WEBHOOK_URL = "https://hooks.example.com/dvvprojects-form";

// Analytics placeholders
export const GA4_MEASUREMENT_ID = "G-XXXXXXXXXX";
export const GTM_CONTAINER_ID = "GTM-XXXXXXX";

// Hero video configuration
export const heroVideo = {
  desktop: "/src/assets/bgvideo.mp4",
  poster: "",
  posterWebp: ""
};
